export var X_FIELD = 'x';
export var Y_FIELD = 'y';
export var COLOR_FIELD = 'name';
export var NODES_VIEW_ID = 'nodes';
export var EDGES_VIEW_ID = 'edges';
//# sourceMappingURL=constant.js.map